import { useState } from "react";
import { View, Text, Pressable } from "react-native";
import { MessageCircle, ChevronRight } from "lucide-react-native";
import { useTranslations } from "@src/packages/i18n";
import { ChatwootSheet } from "@louise/chatwoot";
import { cardSurface } from "@louise/moon-ui";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
import { EMBER } from "../../../onboarding/theme";

export default function ChatWithUsCard() {
  const t = useTranslations();
  const capturePress = usePressCapture("ChatWithUsCard");
  const [chatVisible, setChatVisible] = useState(false);

  return (
    <>
      <Pressable
        onPress={() => {
          capturePress(
            pressLabel(t("chat.have_a_question")),
            "chat.have_a_question",
          );
          setChatVisible(true);
        }}
        style={{
          ...cardSurface(),
          padding: 18,
          flexDirection: "row",
          alignItems: "center",
          gap: 14,
        }}
      >
        <MessageCircle size={22} color={EMBER.colors.text} strokeWidth={1.5} />
        <View style={{ flex: 1, gap: 2 }}>
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 16,
              fontWeight: "600",
              color: EMBER.colors.text,
            }}
          >
            {t("chat.have_a_question")}
          </Text>
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 13,
              color: EMBER.colors.textLight,
              lineHeight: 18,
            }}
          >
            {t("chat.reply_time")}
          </Text>
        </View>
        <ChevronRight
          size={16}
          color={EMBER.colors.textFaint}
          strokeWidth={1.5}
        />
      </Pressable>
      <ChatwootSheet
        visible={chatVisible}
        onClose={() => setChatVisible(false)}
      />
    </>
  );
}
